import httpManager from "@/app/shared/utils/httpManager";

export async function fetchUsers() {
  const response = await httpManager.get("/users/");

  return response?.data;
}
